export enum OrderStatus {
    ORDER_CREATED = 'ORDER_CREATED',
    CUSTOMER_LINK_SHARED = 'CUSTOMER_LINK_SHARED',
    CUSTOMER_DETAILS_UPDATED = 'CUSTOMER_DETAILS_UPDATED',
    PAYMENT_INITIATED_BY_CUSTOMER = 'PAYMENT_INITIATED_BY_CUSTOMER',
    PAYMENT_INITIATED_BY_DEALER = 'PAYMENT_INITIATED_BY_DEALER',
    ORDER_LINK_EXPIRED = 'ORDER_LINK_EXPIRED',
    PAYMENT_SUCCESS_BY_DEALER = 'PAYMENT_SUCCESS_BY_DEALER',
    POLICY_CREATED = 'POLICY_CREATED',
    PAYMENT_FAILED = 'PAYMENT_FAILED',
    PAYMENT_SUCCESS_BY_CUSTOMER = 'PAYMENT_SUCCESS_BY_CUSTOMER',
}

export const DEALER_CANCELLABLE_ORDER_STATUSES = new Set<string>([
    OrderStatus.ORDER_CREATED,
    OrderStatus.CUSTOMER_LINK_SHARED,
    OrderStatus.CUSTOMER_DETAILS_UPDATED,
    OrderStatus.PAYMENT_INITIATED_BY_CUSTOMER,
    OrderStatus.PAYMENT_INITIATED_BY_DEALER,
]);

export const isDealerCancellableOrderStatus = (status: string): boolean =>
    DEALER_CANCELLABLE_ORDER_STATUSES.has(status);
